var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4CAF50;}\r\n\t.st1{fill:#FAFAFA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.91,2.55h-0.12l0,0C116.22,2.55,2.75,116.08,2.75,255.69c0,55.37,17.85,106.68,48.18,148.37L19.38,498.1 l97.3-31.11c40.01,26.53,87.76,41.84,139.23,41.84C395.48,508.83,509,395.26,509,255.69C509,116.12,395.48,2.55,255.91,2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.22,360.01c-6.12,17.26-30.36,31.54-49.66,35.73c-13.25,2.81-30.53,5.07-88.67-19.07 c-74.38-30.8-122.29-106.4-126.04-111.3c-3.57-4.88-30.05-40.02-30.05-76.34c0-36.33,18.44-54.03,25.88-61.63 c6.11-6.22,16.19-9.07,25.88-9.07c3.14,0,5.93,0.15,8.47,0.28c7.43,0.32,11.17,0.75,16.08,12.51c6.12,14.7,20.99,51.02,22.74,54.76 c1.83,3.75,3.62,8.81,1.09,13.72c-2.37,5.07-4.47,7.29-8.21,11.59c-3.72,4.31-7.26,7.6-11,12.22c-3.41,4-7.28,8.32-2.98,15.75 c4.29,7.28,19.18,31.55,41.07,51.05c28.24,25.15,51.17,33.17,59.35,36.6c6.13,2.55,13.4,1.95,17.85-2.82 c5.66-6.09,12.64-16.22,19.78-26.2c5.06-7.12,11.45-8.01,18.14-5.49c6.85,2.37,43.04,20.25,50.45,23.94 c7.44,3.73,12.35,5.51,14.14,8.64C409.31,328.02,409.31,342.73,403.22,360.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.a9e4cc7f8ac109ce5a3fce3fcd123bb5.svg";
export { ForwardRef as ReactComponent };